// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__B55zh","obliqueLineWrap":"membershipbadge_obliqueLineWrap__EcyD0","obliqueLine":"membershipbadge_obliqueLine__4FFnz"};